import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Card } from 'react-native-paper';

import Text from '../Text';

type CountdownProps = {
  until: number; // seconds
  size?: number;
  finishLabel?: string;
  onFinish?: () => void;
};

const Countdown = ({ until, size = 18, finishLabel = 'Now Streaming!', onFinish }: CountdownProps) => {
  const [secondsLeft, setSecondsLeft] = useState(until);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onFinish?.();
      return;
    }

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onFinish?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondsLeft]);

  if (secondsLeft <= 0) {
    return (
      <View style={styles.center}>
        <Text fontWeight="900" style={[styles.released, { fontSize: size }]}>
          {finishLabel}
        </Text>
      </View>
    );
  }

  const days = Math.floor(secondsLeft / (60 * 60 * 24));
  const hours = Math.floor((secondsLeft / (60 * 60)) % 24);
  const minutes = Math.floor((secondsLeft / 60) % 60);
  const seconds = secondsLeft % 60;

  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    <Card mode="elevated" style={styles.card}>
      <Card.Content style={styles.content}>
        <Text
          fontWeight="900"
          style={[
            styles.timer,
            {
              fontSize: size
            }
          ]}>
          {days > 0 && `${days}d`}
          {pad(hours)}h:{pad(minutes)}m:{pad(seconds)}s
        </Text>
      </Card.Content>
    </Card>
  );
};

export default Countdown;

const styles = StyleSheet.create({
  center: {
    alignItems: 'center',
    justifyContent: 'center'
  },

  card: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 12,
    alignSelf: 'center'
  },

  content: {
    alignItems: 'center'
  },

  timer: {
    textAlign: 'center',
    color: 'black',
    fontVariant: ['tabular-nums']
  },

  released: {
    color: 'gold'
  }
});
